import { useNavigate, useParams } from 'react-router-dom'
import { Button, Spinner } from '@chakra-ui/react'
import PageHeader from '../../../components/PageHeader'
import Empty from '../../../components/Empty'
import useSWR from 'swr'
import { useState, useRef } from 'react'
import AdminAffiliateDetail from './AdminAffiliateDetail'
import AdminAffiliateService, {
  AffiliateUpdateState,
  CommissionSummary,
} from '../../../network/services/adminAffiliate'

const AdminAffiliatePage = () => {
  const navigate = useNavigate()

  const formRef = useRef() as any

  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(false)

  // use this to preload
  const {
    data: response,
    error,
    mutate,
  } = useSWR(id !== 'new' ? AdminAffiliateService.get(id!) : null)

  const { data: commissionSummary } = useSWR<CommissionSummary>(
    id !== 'new' ? AdminAffiliateService.getCommissionSummary(id!) : null
  )

  if (error) {
    console.log(error)
    return <Empty description={`エラーが発生しました。${error?.message}`} />
  }

  if (!response && id !== 'new') {
    return (
      <PageHeader>
        <Spinner />
      </PageHeader>
    )
  }

  const refresh = () => {
    if (id != null) {
      if (id === 'new') {
      } else {
        mutate()
      }
    }
  }

  const saveAction = (
    <Button
      key={'保存する'}
      onClick={() => {
        if(formRef.current)
          formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
      }}
      isLoading={isLoading}
    >
      保存する
    </Button>
  )

  // const discardAction = (
  //   <Button
  //     key={'削除する'}
  //     type='default'
  //     // onClick={async () => {
  //     //   await CollaboratorService.remove(appClientId!, id!)
  //     //   navigate('/dashboard/collaborators')
  //     // }}
  //   >
  //     Discard
  //   </Button>
  // )

  return (
    <PageHeader
      title={'アフィリエイト管理'}
      onBack={() => navigate('/admin/dashboard/affiliates')}
      extra={[
        saveAction,
        //discardAction
      ]}
    >
      <AdminAffiliateDetail
        formRef={formRef}
        initialValue={response}
        commissionSummary={commissionSummary}
        refresh={refresh}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </PageHeader>
  )
}

export default AdminAffiliatePage
